import { useQuery } from 'react-query'
import { useApplicationCtx } from 'context/application'
import { TCheckinData } from 'interface'
import { QueryKeys } from 'common/constants'

import { IWbHttpData } from '@interco/inter-webview-bridge'
import { TrackData } from '@interco/track'

interface IResponse extends Omit<IWbHttpData, 'response'> {
  response: TCheckinData
}

export default function useGetCheckinData() {
  const { httpHandler } = useApplicationCtx()
  const request = {
    url: '/app/meios-pagamentos/bff/v1/loyalty/daily-check-in',
    method: 'GET',
  }

  return {
    ...useQuery(
      [QueryKeys.CHECKIN_LIST],
      async () => {
        TrackData.log({
          url: request.url,
          method: request.method,
          event: 'START_REQUEST',
        })

        return httpHandler.get(request.url, {
          'x-inter-theme': 'PF',
        }) as Promise<IResponse>
      },
      {
        select(response) {
          let parsedData: TCheckinData

          if (typeof response.response === 'string') {
            parsedData = JSON.parse(response.response) as TCheckinData
          } else {
            parsedData = response.response || { sections: [] }
          }

          const hasToday = parsedData.sections?.some((section) => {
            if (!section.content || section.content.length === 0) return false

            return section.content.some((contentItem) => {
              const { sectionItems } = contentItem

              if (!sectionItems || sectionItems.length === 0) return false

              return sectionItems.some((item) => {
                if (!('checkIns' in item)) return false

                return item.checkIns.some(
                  (checkIn) => checkIn.content.text?.toLowerCase() === 'hoje',
                )
              })
            })
          })

          const hasCheckedDay7 = parsedData.sections?.some((section) => {
            if (!section.content || section.content.length === 0) return false

            return section.content.some((contentItem) => {
              const { sectionItems } = contentItem

              if (!sectionItems || sectionItems.length === 0) return false

              return sectionItems.some((item) => {
                if (!('checkIns' in item)) return false

                return item.checkIns.some((checkIn) => checkIn.content.state === 'DAY_7_CHECKED')
              })
            })
          })

          return {
            ...parsedData,
            isCampaignActive: hasToday || hasCheckedDay7,
          }
        },
        onSuccess() {
          TrackData.log({
            url: request.url,
            method: request.method,
            event: 'SUCCESS_REQUEST',
          })
        },
        onError(error) {
          TrackData.error({
            url: request.url,
            method: request.method,
            event: 'ERROR_REQUEST',
            error: error?.toString(),
          })
        },
      },
    ),
  }
}
